import { createContext } from "react";

import { IAssessmentInvite } from "@/shared/hooks/initializer/use-initialize-candidate.hook";

import { ITest, ResolvedLocalizedContent } from "@/modules/assessments/types/test.interface";
import { ICandidateAssessment } from "@/modules/assessments/assessments.types";

export interface IGroupConfig {
  size?: number;
  header?: ResolvedLocalizedContent;
}

export interface ICurrentPageContext {
  currentTest?: ITest;
  invite?: IAssessmentInvite;
  assessment?: ICandidateAssessment;
  groupConfig?: IGroupConfig;
}

export const InviteContext = createContext<ICurrentPageContext>({});
